module.exports = __webpack_public_path__ + "static/appstore-aa12b52fe6ebe96643fc3ed9c8432caa.png";